import React from 'react';
import { format } from 'date-fns';

const FormattedTime = ({
  time
}) => {
  return /* @__PURE__ */ React.createElement("span", null, format(new Date(time.dateTime), time.timeFormat));
};

export { FormattedTime };
